<template>
  <div class="browser">
    <i id="arrow" class="anyteachicon anyteach-arrow-up" />
    <div class="content">
      <img
        class="browser-icon"
        id="ios-browser"
        v-if="$store.state.isIOS"
        src="https://anyteach.oss-cn-shanghai.aliyuncs.com/img/safari.png?x-oss-process=image/resize,h_100"
      />
      <i v-else id="android-browser" class="browser-icon anyteachicon anyteach-android-browser" />
      <h1>
        点击右上角
        <i class="anyteachicon anyteach-3dot" />
        <br />
        {{ $store.state.isIOS ? "在 Safari 中打开" : "用浏览器打开"}}
      </h1>
      <div class="back">
        <span>或</span>
        <div @click="back" class="button">
          返回使用微信支付
          <i class="anyteachicon anyteach-wechat-pay" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  methods: {
    back() {
      this.$router.push(`?pay=1&cd_id=${this.$route.query.cd_id}&method=wechat`)
    }
  }
}
</script>

<style lang="scss" scoped>
.browser {
  top: 0;
  left: 0;
  position: fixed;
  background: rgba(255, 255, 255, 0.92);
  z-index: 100;
  height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  animation-delay: 0s !important;
  animation-duration: 0.3s !important;

  .back {
    margin-top: 50px;
  }
  .button {
    margin: 0;
    background: none;
    color: $blue;
    width: 100%;
    padding: 0;
    text-align: center;
    color: #1ab20a;
    i {
      color: #1ab20a;
    }
  }
}
#arrow {
  position: absolute;
  top: 10px;
  right: 15px;
  font-size: 30px;
  animation-delay: 0;
  animation: 1.2s ease infinite upDown;
  -webkit-animation: 1.2s ease infinite upDown;
  -moz-animation: 1.2s ease infinite upDown;
  color: $blue;
}

.browser-icon {
  margin: 0 0 10px;
  box-shadow: $deep-shadow;
  border-radius: 10px;
  border: 1px solid #e9e9e9;
}
#ios-browser {
  width: 70px;
}

#android-browser {
  font-size: 50px;
  line-height: 1;
  display: inline-block;
  padding: 10px;
}
.content {
  text-align: center;

  span {
    font-size: 0.8rem;
    opacity: 0.6;
  }
}
h1 {
  font-size: 1.25rem;
  margin: 0 0 8px 0;
  line-height: 1.25;
}
h2 {
  font-size: 1rem;
  margin: 0;
  opacity: 0.6;
  font-weight: 400;
}
@keyframes upDown {
  0% {
    top: 10px;
  }
  50% {
    top: 25px;
  }
  100% {
    top: 10px;
  }
}
</style>